module.exports = "fuse-quick-panel {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 350px;\n  min-width: 280px;\n  max-width: 380px;\n  z-index: 99;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n  fuse-quick-panel .mat-slide-toggle-content {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/quick-panel/quick-panel.component.scss
// module id = ./src/app/main/quick-panel/quick-panel.component.scss
// module chunks = main